module.exports = __webpack_public_path__ + "img/user_img_default.6bb64a96.png";